import {Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {AccountingOffice, AccountingOfficeApiService} from 'patja-api';
import {Observable, of, tap} from 'rxjs';
import {NzConfigService} from 'ng-zorro-antd/core/config';

@Injectable({
  providedIn: 'root',
})
export class AccountingOfficeService {
  private accountantOffice: WritableSignal<AccountingOffice | null> = signal(null);

  constructor(
    private accountingOfficeApiService: AccountingOfficeApiService,
    private nzConfigService: NzConfigService,
  ) {}

  getAccountingOfficeSignal(): Signal<AccountingOffice | null> {
    return this.accountantOffice.asReadonly();
  }

  getAccountingOfficeForUser(
    activeAccountingOfficeId?: string | null,
  ): Observable<AccountingOffice | null> {
    if (!activeAccountingOfficeId) {
      return of(null);
    }

    if (this.accountantOffice()?.id === activeAccountingOfficeId) {
      return of(this.accountantOffice());
    }

    return this.accountingOfficeApiService
      .getAccountingOfficeById(activeAccountingOfficeId)
      .pipe(tap((office: AccountingOffice) => this.setAccountingOfficeTheme(office)));
  }

  fetchAccountingOfficeForCompany(companyId: string): Observable<AccountingOffice> {
    return this.accountingOfficeApiService
      .getAccountingOfficeByCompanyId(companyId)
      .pipe(tap((office: AccountingOffice) => this.setAccountingOfficeTheme(office)));
  }

  clearAccountingOffice(): void {
    this.accountantOffice.set(null);
  }

  private setAccountingOfficeTheme(office: AccountingOffice): void {
    this.nzConfigService.set('theme', {primaryColor: office.primaryColor});
    this.accountantOffice.set(office);
  }
}
